import { House } from "lucide-react";

import { ButtonLink } from "@/components/ui";
import { useT } from "@/i18n/provider";
import { Page } from "./page";

/**
 * "You do not have access to this": inside the app's frame, so the menu is
 * still there to go somewhere the person may go. Never a blank page.
 */
export function ForbiddenPage() {
  const t = useT();
  return (
    <Page title={t.appName}>
      <Message text={t.errors.forbidden} homeLabel={t.home} />
    </Page>
  );
}

/** An address that is not in the app. On its own: it may be opened signed out. */
export function NotFoundPage() {
  const t = useT();
  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-4">
      <Message text={t.errors.not_found} homeLabel={t.home} />
    </main>
  );
}

function Message({ text, homeLabel }: { text: string; homeLabel: string }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-6 text-center">
      <img src="/icon-192.png" alt="" width={88} height={88} className="rounded-card" />
      <p role="alert" className="max-w-md text-heading font-bold text-text">
        {text}
      </p>
      <ButtonLink to="/" label={homeLabel} icon={House} />
    </div>
  );
}
